const form = () => {
    const registerForm = document.getElementById('register-form')
    if (!registerForm) return

    const FFS_CONTACTS_API = {
        url: '/wp-json/emerald-bay/register',
    }

    const MHUB_API = {
        enabled: true,
        url: '/wp-json/emerald-bay/submit',
    }

    const formInputs = {
        salutation: registerForm.querySelector('select[name="eden-title"]'),
        name: registerForm.querySelector('input[name="eden-fullname"]'),
        email: registerForm.querySelector('input[name="eden-email"]'),
        country: registerForm.querySelector('select[name="eden-countrycode"]'),
        phone: registerForm.querySelector('input[name="eden-contact"]'),
        consent: registerForm.querySelector('input[name="pdpa"]'),
    }

    // must be abc@123.com
    const REGEX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const REGEX_PHONE = /^[0-9]{9,10}$/
    const error_messages = registerForm.querySelectorAll('.error-message')

    const preloader = registerForm.querySelector('.preloader-overlay')

    registerForm.addEventListener('submit', async (e) => {
        e.preventDefault()
        if (preloader) preloader.classList.add('show')

        let error_flag = false

        // clear error messages
        error_messages.forEach((error_message) => error_message.classList.remove('show'))

        Object.keys(formInputs).forEach((key) => {
            if (key === 'consent') return
            if (!formInputs[key]?.value?.trim()) {
                document.querySelector(`.error-message[${formInputs[key]?.name}]`)?.classList.add('show')
                error_flag = true
                return
            }

            if (key === 'email' && !REGEX_EMAIL.test(formInputs[key].value.trim())) {
                document
                    .querySelector(`.error-message[${formInputs[key].name}-invalid]`)
                    ?.classList.add('show')
                error_flag = true
                return
            }

            if (key === 'phone' && !REGEX_PHONE.test(formInputs[key].value.trim())) {
                document
                    .querySelector(`.error-message[${formInputs[key].name}-invalid]`)
                    ?.classList.add('show')
                error_flag = true
                return
            }

            if (key === 'consent' && !formInputs[key].checked) {
                document.querySelector('.error-message[eden-pdpa]')?.classList.add('show')
                error_flag = true
            }
        })

        if (!error_flag) {
            // proceed
            const countrycode = document.querySelector('[name="eden-countrycode"]').value ?? '+60'
            const PAYLOAD = {
                salutation: formInputs.salutation.value,
                name: formInputs.name.value,
                email: formInputs.email.value,
                contactno: countrycode + formInputs.phone.value,
                consent: formInputs.consent.checked,
                remarks: document.querySelector('[name="eden-message"]').value,
            }

            try {
                const response = await fetch(FFS_CONTACTS_API.url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(PAYLOAD),
                })

                let res

                try {
                    res = await response.json()
                } catch (err) {
                    throw new Error('Invalid JSON response')
                }

                // Check for HTTP errors or WordPress WP_Error format
                if (!response.ok) {
                    // WordPress sends message in res.message when error
                    const msg = res?.message || `HTTP error! status: ${response.status}`
                    throw new Error(msg)
                }

                // MHUB API
                if (MHUB_API.enabled) {
                    try {
                        const current_url = window.location.href
                        PAYLOAD.current_url = current_url

                        const response = await fetch(MHUB_API.url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(PAYLOAD),
                        })

                        let mhubres

                        try {
                            mhubres = await response.json()
                        } catch (err) {
                            throw new Error('Invalid JSON response')
                        }

                        // Check for HTTP errors or WordPress WP_Error format
                        if (!response.ok) {
                            // WordPress sends message in res.message when error
                            const msg = mhubres?.message || `HTTP error! status: ${response.status}`
                            throw new Error(msg)
                        }
                        // console.log(mhubres)
                        if (res.trx_status && res.trx_status === 'success') {
                            window.location.href = 'thank-you'
                        } else {
                            if (preloader) preloader.classList.remove('show')
                            alert(res?.message || 'Submission failed. Please try again.')
                        }
                    } catch (error) {
                        if (preloader) preloader.classList.remove('show')
                        alert(error.message)
                        console.error('Request failed:', error)
                    }
                } else {
                    if (res.trx_status && res.trx_status === 'success') {
                        window.location.href = 'thank-you'
                    } else {
                        if (preloader) preloader.classList.remove('show')
                        alert(res?.message || 'Submission failed. Please try again.')
                    }
                }
            } catch (error) {
                if (preloader) preloader.classList.remove('show')
                alert(error.message)
                console.error('Request failed:', error)
            }
        } else {
            // do not proceed
            if (preloader) preloader.classList.remove('show')
        }
    })
}

export default form
